import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Input, Button, Upload, Progress, message } from 'antd';
import { FormattedMessage } from "react-intl";
import classnames from "classnames";
import { getBase64 } from '../../utils/CommonUtils';
import {EditOutlined} from "@ant-design/icons";
import uploadImg from "@assets/img/icon/uploadImg.svg";
import delet from "@assets/img/icon/deleteImg.svg";
import {GetToken} from "@services/AuthService";

function ImgUpload({value, onChange, children, handleLoading, ...resProps}) {
    const [loading, setLoading] = useState(false);
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [imageName, setImageName] = useState('');
    const [progress, setProgress] = useState('');
    useEffect(() => {
        setImageUrl(value)
        setImagePreviewUrl(value);
        setLoading(false);
        setProgress('0');
    }, [value])

    useEffect(() => {
        handleLoading && handleLoading(loading)
    },[loading])

 
    const progressChange = (e) => {
        // setLoading(false);
        setProgress(Number(e.percent).toFixed(1));
    }
    const handleError = (err) => {
        setProgress('0');
        message.error("error_uploading");
    }
    const onEmitFile = (e) => {
        console.log(e)
    }
    const handleChange = info => {
        if (info.file.status === 'uploading') {
            setImageName(info.file.name);
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            setImageUrl(info.file.response.url)
            onChange(info.file.response.url)
            getBase64(info.file.originFileObj, url => {
                setImagePreviewUrl(url);
                setLoading(false);
                setProgress('0');
            }
            );
        }
    }
    const changeFile = () => {
    }
    const deleteFile = (e) => {
        setImagePreviewUrl('');
        setImageUrl('');
        onChange('');
        e.stopPropagation();
    }
    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }
    const LoadingProgres = (
        <div className="progress-bar">
            <p><FormattedMessage id="uploading" /></p>
            <p className="file-name one-row">{imageName}</p>
            <Progress percent={progress} status="active" />
        </div>
    );
    const uploadButton = (
        <div className="uploadFileContent">
            <p className="ant-upload-drag-icon">
                <img src={uploadImg} alt="icon" />
            </p>
            <p className="ant-upload-text">{<FormattedMessage id='drag_and_drop_or' />} <span className="marked">{<FormattedMessage id='browse' />}</span></p>
            <p className="ant-upload-hint">{<FormattedMessage id='jpeg_png_gif_less_than_2mb_min_width_400px' />}</p>
        </div>
    );
    const previewBlock = (
        <div className="uploadFileContent">
            <img src={imagePreviewUrl} alt="avatar" className="uploadFileContent--img" />
            <div className="uploadFileContent--infoBox">
                <p className="uploadFileContent--infoBox--title">{imageName}</p>
                <div className="uploadFileContent--infoBox--btnGroup">
                    <Button onClick={changeFile}>
                        <span className="text"><FormattedMessage id={"change"}/></span>
                        <EditOutlined />
                    </Button>
                    <Button onClick={deleteFile}>
                         <span className="text"><FormattedMessage id={"delete"}/></span>
                         <span className="delete-upload-icon"></span>
                    </Button>
                </div>

            </div>
        </div>
    );
    return (
        <div className={`uploadFileContent ${imagePreviewUrl ? "uploaded" : ""}`}>
            <Input  type="hidden" {...resProps} value={imageUrl} onChange={onChange} />
            <Upload.Dragger name="file"
                listType="picture-card"
                disabled={loading}
                className={classnames({ "avatar-uploader": imagePreviewUrl, "preview-uploader": !imagePreviewUrl })}
                showUploadList={false}
                beforeUpload={beforeUpload}
                onProgress={progressChange}
                action={`${process.env.BINARY_OPTION_API_PATH}/rate/files`}
                headers={{
                    Authorization: `Bearer ${GetToken()}`,
                }}
                onChange={handleChange} >
                {children ? children : imagePreviewUrl ? previewBlock : uploadButton}
            </Upload.Dragger>
        </div>
    )
}
function mapStateToProps(state) {
    return {
    }
}
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ImgUpload);